import API from "@fetcher/fetcher";
import { ELoadingOptions } from "@modules/loader/useLoader.hook";
import type { IClaim } from "./models/IClaim";
import type { IReward } from "./models/IReward";

const BASE_URL = "/reward";

export default class RewardAPI {
  static getRewardList = async () =>
    API.get<IReward[]>(BASE_URL).then((res) => res.data);

  static orderReward = async (rewardId: number) =>
    API.post<IClaim>(`/me/claim/${rewardId}`, {}, ELoadingOptions.MODAL).then(
      (res) => res.data,
    );
}
